module.exports = __webpack_public_path__ + "static/media/requirements2.1057089c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/requirements2.png
// module id = 55
// module chunks = 0